import React, {useCallback} from 'react';
import Container from 'components/layout/Container';
import ArrowLeft from 'components/ui/icon/ArrowLeft';
import {useNavigate, useLocation} from 'react-router-dom';

import './PureHeader.scss';

function PureHeader() {
  const navigate = useNavigate();
  const {hash} = useLocation();

  const onClick = useCallback(() => {
    if (hash === '#form') {
      navigate(-2);
    } else {
      navigate(-1);
    }
  }, [hash]);

  return (
    <header className="pure-header">
      <Container extraClassName="pure-header__wrapper">
        <div className="pure-header__icon-container" onClick={onClick}>
          <ArrowLeft extraClassName="pure-header__arrow-left" />
        </div>
      </Container>
    </header>
  );
}

export default PureHeader;
